<template>
  <div>
    <Select multiple filterable @change="onChange" v-model="selectedValues">
      <Option
        v-for="item in items"
        :value="item.code"
        :label="item.code"
        :key="item.id"
      />
    </Select>
  </div>
</template>

<script>
import { request } from "@/api/all";

import "element-ui/lib/theme-chalk/index.css";
import { Select, Option } from "element-ui";

export default {
  components: {
    Select,
    Option
  },
  props: {
    typeId: {
      type: String,
      default: () => null
    },
    selectedValue: {
      type: String,
      default: () => null
    }
  },
  data() {
    return {
      selectedValues: [],
      items: []
    };
  },
  mounted() {
    this.init();
  },
  methods: {
    init() {
      if (this.selectedValue != null)
        this.selectedValues = this.selectedValue.split(", ");
      request({
        api: { method: "GET", url: "asset/ItemsBySiteId" },
        params: { locTypeId: this.typeId },
        store: this.$store
      }).then(res => {
        if (res != false) {
          this.items = res.data.list;
          //console.log("res");
        }
      });
    },
    onChange(e) {
      if (e != undefined) {
        this.$emit("input", e.join(", "));
      }
    }
  }
};
</script>
